import React, { useContext, useState } from 'react';

import Close from '../../Reutilizaveis/CloseButton';

import { Spinner } from '../../StyledComponent';

import { ContextoFinanceiro } from '../../../services/financeiro';
import { ContextoListaApartamentos } from '../../ApartamentList/contextoImoveis';
import styled from 'styled-components';

import { ReactComponent as Email } from '../../../assets/novosicones/Financeiro/mail_black_24dp.svg';

import './styles.scss';

export const ExibirExtratoIrrf = ({
  base64,
  tipo,
  setshowParcelasPagar,
  setGerarExtrato,
  setGerarIrrf,
  base64WithChecksum,
}) => {
  const [loadingEnviarEmail, setLoadingEnviarEmail] = useState(false);

  const [msgSucessoEmailEnviado, setMsgSucessoEmailEnviado] = useState(false);

  const { postEnviarExtratoEmail, postEnviarIrrfEmail } =
    useContext(ContextoFinanceiro);

  const { tema } = useContext(ContextoListaApartamentos);

  const estiloReceberEmail = {
    width: '100%',
    justifyContent: 'flex-end',
    marginTop: '25px',
  };

  const estiloBtnReceberEmail = {
    backgroundColor: 'transparent',
    border: 'none',
    color: msgSucessoEmailEnviado ? '#d1d1d1' : tema.primaryColor,
    fontSize: '19px',
    textDecoration: 'underline',
    fontWeight: '900',
  };

  const enviaExtratoPorEmail = async () => {
    setLoadingEnviarEmail(true);
    try {
      await postEnviarExtratoEmail(base64WithChecksum);
      setMsgSucessoEmailEnviado(true);
    } catch (error) {
      return [];
    }
    setLoadingEnviarEmail(false);
  };

  const enviaIrrfPorEmail = async () => {
    setLoadingEnviarEmail(true);
    try {
      await postEnviarIrrfEmail(base64WithChecksum);
      setMsgSucessoEmailEnviado(true);
    } catch (error) {
      return [];
    }
    setLoadingEnviarEmail(false);
  };

  const Container = styled.div`
    width: 960px;
    @media (max-width: 768px) {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  `;

  // const PdfMobile = styled.div`
  //   display: none;
  //   @media (max-width: 768px) {
  //     display: block;
  //   }
  // `;

  // const PdfDesktop = styled.div`
  //   display: block;
  //   @media (max-width: 768px) {
  //     display: none;
  //   }
  // `;

  const CloseBtn = styled.span`
    position: absolute;
    right: -25px;
    top: -25px;
    cursor: pointer;
    @media (max-width: 768px) {
      top: -30px;
    }
  `;

  return (
    <div className='centralized-column' style={{ marginTop: '50px' }}>
      <Container>
        <div style={{ position: 'relative' }}>
          <CloseBtn
            onClick={() => {
              setshowParcelasPagar(true);
              setGerarExtrato(false);
              setGerarIrrf(false);
              document.getElementById(
                'divResumoParcelasSelecionadas'
              ).style.display = 'block';
            }}
            id='btnFecharExtratoIrrf'
          >
            <Close corBackground='#ffffff' tamanho='35px' />
          </CloseBtn>
          <div className='pdfDesktop'>
            <embed
              src={`data:application/pdf;base64,${base64}`}
              type='application/pdf'
              width='850'
              height='915'
            />
          </div>
          <div className='pdfMobile'>
            <p>
              Ups, parece que seu browser não suporta esta funcionalidade,{' '}
              <a
                target='_blank'
                rel='noreferrer'
                href={`data:application/pdf;base64,${base64}`}
              >
                clique aqui para fazer download do pdf .
              </a>
            </p>
          </div>
        </div>

        <div className='receber-email centralized' style={estiloReceberEmail}>
          {tipo == 'extrato' && (
            <button
              style={estiloBtnReceberEmail}
              onClick={() => {
                enviaExtratoPorEmail();
              }}
            >
              {loadingEnviarEmail && <Spinner />}
              {!loadingEnviarEmail &&
                !msgSucessoEmailEnviado &&
                `Receber por email`}
              {!loadingEnviarEmail &&
                msgSucessoEmailEnviado &&
                `Email enviado com sucesso`}
            </button>
          )}
          {tipo == 'irrf' && (
            <button
              style={estiloBtnReceberEmail}
              onClick={() => {
                enviaIrrfPorEmail();
              }}
            >
              {loadingEnviarEmail && <Spinner />}
              {!loadingEnviarEmail &&
                !msgSucessoEmailEnviado &&
                `Receber por email`}
              {!loadingEnviarEmail &&
                msgSucessoEmailEnviado &&
                `Email enviado com sucesso`}
            </button>
          )}
          {!loadingEnviarEmail && (
            <Email
              style={
                msgSucessoEmailEnviado
                  ? { fill: '#d1d1d1', marginLeft: '5px' }
                  : { fill: tema.primaryColor, marginLeft: '5px' }
              }
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default ExibirExtratoIrrf;
